import * as React from 'react'

const TemplateOptionSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={92} height={92} {...props}>
    <g data-name="Group 1748" transform="translate(-816 -257)">
      <rect
        data-name="Rectangle 1063"
        width={92}
        height={14}
        rx={2}
        transform="translate(816 257)"
        style={{
          fill: '#719fbd'
        }}
      />
      <rect
        data-name="Rectangle 1065"
        width={52}
        height={14}
        rx={2}
        transform="translate(856 274)"
        style={{
          fill: '#c9c9c9'
        }}
      />
      <rect
        data-name="Rectangle 1066"
        width={52}
        height={14}
        rx={2}
        transform="translate(856 291)"
        style={{
          fill: '#e2e2e2'
        }}
      />
      <rect
        data-name="Rectangle 1067"
        width={52}
        height={15}
        rx={2}
        transform="translate(856 308)"
        style={{
          fill: '#c9c9c9'
        }}
      />
      <rect
        data-name="Rectangle 1064"
        width={38}
        height={49}
        rx={2}
        transform="translate(816 274)"
        style={{
          fill: '#e2e2e2'
        }}
      />
      <rect
        data-name="Rectangle 1068"
        width={92}
        height={23}
        rx={2}
        transform="translate(816 326)"
        style={{
          fill: '#68942f'
        }}
      />
    </g>
  </svg>
)

export default TemplateOptionSVG
